/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Loading } from '@descomplica/foundation-ui-components';
import React from 'react';

import IconComponent from '@/presentation/components/icon/icon';
import loading from '@/presentation/components/loading';

import {
  Actions,
  CancelationActionButton,
  ConfirmationActionButton,
  Container,
  Description,
  MyModal,
  Title,
} from './styles';

type Props = {
  isOpen: boolean;
  isSendingConfirmation?: boolean;
  title?: string;
  description?: string | React.ReactElement;
  confirmActionButton?: React.ReactElement;
  cancelActionButton?: React.ReactElement;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
};

const ConfirmDialog: React.FC<Props> = ({
  isOpen,
  isSendingConfirmation,
  title,
  description,
  confirmActionButton,
  cancelActionButton,
  cancelButtonLabel,
  confirmButtonLabel,
  onCancel,
  onConfirm,
}) => {
  if (!isOpen) {
    return null;
  }

  const CancelActionButton = () => {
    if (cancelActionButton) {
      return cancelActionButton;
    }

    return (
      <CancelationActionButton onClick={onCancel}>
        <IconComponent name="whiteArrow" />
        <span>{cancelButtonLabel}</span>
      </CancelationActionButton>
    );
  };

  const ConfirmActionButton = () => {
    if (confirmActionButton) {
      return confirmActionButton;
    }

    return (
      <ConfirmationActionButton onClick={onConfirm}>
        <IconComponent name="plus" />
        <span>{confirmButtonLabel}</span>
      </ConfirmationActionButton>
    );
  };

  return (
    <MyModal>
      <Container>
        {!isSendingConfirmation ? (
          <>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
            <Actions>
              <CancelActionButton />
              <ConfirmActionButton />
            </Actions>
          </>
        ) : (
          <Loading />
        )}
      </Container>
    </MyModal>
  );
};

ConfirmDialog.defaultProps = {
  cancelButtonLabel: 'Cancelar',
  confirmButtonLabel: 'Confirmar',
};

export default ConfirmDialog;
